// @flow
// Types

// Constants
import {
  // Model Properties
  PROP_SEASON,
  PROP_NAME,
  PROP_HEFTY_PRIMARY_NUTRIENTS,
  PROP_STATE,
  PROP_USGALLONSPERMT,
  PROP_ASSET,
  PROP_RX_NAME,

  LIQUID,
} from '../constants'

// Export
export default function validateModel (model: Object): Array<{ [string]: string }> {
  const errors = []

  if (!model[PROP_NAME]) {
    errors.push({ [PROP_NAME]: 'nameIsRequired' })
  }

  if (!model[PROP_HEFTY_PRIMARY_NUTRIENTS]) {
    errors.push({ [PROP_HEFTY_PRIMARY_NUTRIENTS]: 'primaryNutrientsIsRequired' })
  }

  if (!model[PROP_ASSET]) {
    errors.push({ [PROP_ASSET]: 'assetIsRequired' })
  }

  if (!model[PROP_SEASON]) {
    errors.push({ [PROP_SEASON]: 'seasonIsRequired' })
  }

  if (model[PROP_STATE] === LIQUID) {
    if (!model[PROP_USGALLONSPERMT]) {
      errors.push({ [PROP_USGALLONSPERMT]: 'usgallonspermtIsRequired' })
    }
  }

  if (model[PROP_RX_NAME] && model[PROP_RX_NAME].length > 4) {
    errors.push({ [PROP_RX_NAME]: 'rxNameIsTooLong' })
  }

  return errors
}
